




















































import 'reflect-metadata'
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import { toDCM } from '@/helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'
import EVMTransactionRow from '@/components/Transaction/EVMTransactionRow.vue'

@Component({
    components: {
        Tooltip,
        EVMTransactionRow,
    },
    filters: {
        toDCM,
    },
})
export default class EVMTransactions extends Mixins(TransactionsGettersMixin) {
    @Prop() txs!: ParsedEVMTx[]
    @Prop() limits!: number[]
    limit = this.limits[0]

    @Watch('limit')
    updateLimit() {
        this.$emit('update', this.limit)
    }

    next() {
        this.$emit('next')
    }

    back() {
        this.$emit('back')
    }

    get isStartingTransaction() {
        return this.txs.at(0)?.hash === this.getEVMTxs().at(0)?.hash
    }

    get isLastTransaction() {
        return (
            this.txs.at(this.txs.length - 1)?.hash ===
            this.getEVMTxs().at(this.totalTransactions - 1)?.hash
        )
    }

    get totalTransactions() {
        return this.getEVMTxs().length
    }
}
